// src/js/home/day-snap.ts
//
// (a) D-14 / P-05 LOCKED: this is the ONLY sanctioned snap-to-nearest-day rounding for HOME-03.
//     Extracted verbatim from crosshair-sync.ts:96-100, where it was already proven correct.
// (b) `pointStart % dayMs` is what makes this DST-correct — it aligns the rounding to the
//     series' own local-midnight origin instead of assuming UTC midnight.
// (c) A fixed-hour compensating offset (e.g. `rawMs + 12h`) is explicitly FORBIDDEN — it would
//     break twice a year, once on each DST transition (spring-forward/fall-back).
// (d) Deliberately zero-import so tools/probe-262-dst-snap.mjs can import the real module
//     directly under Node's native TypeScript type stripping — no browser, no bundler.

/**
 * Snap a raw millisecond timestamp to the nearest day boundary, aligned to a series'
 * `pointStart` (its local-midnight origin). Correct across DST transitions because the
 * alignment offset is derived from `pointStart` itself, never a fixed-hour constant.
 *
 * @param rawMs - Raw timestamp, typically from `xAxis[0].toValue(...)`.
 * @param pointStart - The series' own `options.pointStart` (local-midnight epoch).
 * @returns `rawMs` rounded to the nearest day, aligned to `pointStart`'s intra-day offset.
 */
export function snapToDayMs(rawMs: number, pointStart: number): number {
    const dayMs = 86400000;
    const offset = pointStart % dayMs;
    return Math.round((rawMs - offset) / dayMs) * dayMs + offset;
}
